import { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
// Models
import { IMessage } from 'app/models/ChatAI';
// Mui
import { Tooltip } from '@mui/material';
// Icons
import {
  Check as CheckIcon,
  ContentCopy as ContentCopyIcon
} from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
// Hooks
import useCopyToClipboard from 'app/hooks/useCopyToClipboard';
import useParseMarkdownToHTML from './useParseMarkdownToHTML';

interface Props {
  message: IMessage;
}

export default function RefineMessageCopyButton({ message }:Props){
  const { t } = useTranslation();

  const [ asyncCopyTextToClipboardFn, copied ] = useCopyToClipboard();

  const rawHtml = useParseMarkdownToHTML(message);

  const handleClick = useCallback(async () => {
    try {
      await asyncCopyTextToClipboardFn(rawHtml, false);
    } catch(error){
      console.log(error);
    }
  }, [rawHtml, asyncCopyTextToClipboardFn]);

  return (
    <Fragment>
      <Tooltip title={copied ? t('labels.copied') : t('labels.copy')}>
        <IconButton
          name={`Copy ${message.id}`}
          onClick={handleClick}
          size="small"
        >{copied ? (
          <CheckIcon color="success" fontSize="small" />
        ) : (
          <ContentCopyIcon fontSize="small" />
        )}</IconButton>
      </Tooltip>
    </Fragment>
  )
};
